export default "__VITE_ASSET__Bz9PJ4WA__"